import { isExperimentOn } from '@wix/domains-serverless-interface';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';
export const useIsGateRevamp3Enabled = () => {
  var _getPremiumEssentials;
  return isExperimentOn((_getPremiumEssentials = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials = _getPremiumEssentials.experiments) == null ? void 0 : _getPremiumEssentials[ExperimentSpecs.GateRevamp3]);
};
//# sourceMappingURL=useIsGateRevamp3Enabled.js.map